import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "@/lib/auth";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Landing from "@/pages/Landing";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";
import AuthCallback from "@/pages/AuthCallback";
import About from "@/pages/About";
import Thoughts from "@/pages/Thoughts";
import Tools from "@/pages/Tools";
import CompoundInterest from "@/pages/tools/CompoundInterest";
import MonteCarloDCF from "@/pages/tools/MonteCarloDCF";
import ISLM from "@/pages/tools/ISLM";
import GoalPlanner from "@/pages/tools/GoalPlanner";
import PensionPlanning from "@/pages/tools/PensionPlanning";

function AppRouter() {
  const location = useLocation();
  // Synchronous check for OAuth callback — must run before ProtectedRoute
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <Nav />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/thoughts" element={<Thoughts />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/tools" element={<Tools />} />
        <Route path="/tools/compound-interest" element={<CompoundInterest />} />
        <Route path="/tools/monte-carlo-dcf" element={<MonteCarloDCF />} />
        <Route path="/tools/is-lm" element={<ISLM />} />
        <Route path="/tools/goal-planner" element={<GoalPlanner />} />
        <Route path="/tools/pension-planning" element={<PensionPlanning />} />
        <Route path="/about" element={<About />} />
        <Route path="/login" element={<Login />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="*" element={<Landing />} />
      </Routes>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <AuthProvider>
          <BrowserRouter>
            <AppRouter />
            <Toaster position="top-right" richColors />
          </BrowserRouter>
        </AuthProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
